import {h, Component, Fragment} from "preact";
import {route} from "preact-router";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import PFeed from "../../../services/prematch-feed";
import Page from "../../../services/page-data-feed";
import Config from "../../../services/config";
import Ticket from "../utils/ticket-logic.jsx";

import * as M from "../desktop-templates/prematch-menu.jsx";
import * as P from "../desktop-templates/prematch-tournament.jsx";
import {StatsIconRegular} from "../utils/icons.jsx";

export default class PrematchLastminute extends Component {
	componentWillMount() {
		PFeed.getMenu(() => this.setState({}))
	}
	bestSport(menu) {
		return Object.values(menu).sort((a, b) => a.order - b.order)[0]
	}
	render() {
		if (!PFeed.menu)
			return;
		const sport = this.bestSport(PFeed.menu);
		return <PrematchLastminuteContent defaultSport={sport.id} />
	}
}

export class PrematchLastminuteContent extends Component {
	preferredMarkets = {
		'/sport/1': {id: 14, outcomes: 3},
		'/sport/7': {id: 5, outcomes: 2},
		'/sport/9': {id: 39, outcomes: 2},
		'/sport/10': {id: 6, outcomes: 3},
		'/sport/26': {id: 4, outcomes: 2},
	};

    state = {
		currentSport: null,
		tournament: null
    };

    componentWillMount() {
		this.setState({
			currentSport: this.props.defaultSport
		});
		this.downloadSport(this.props.defaultSport);
    }
	downloadSport(sportId) {
		Page.openNextEventsMerged(sportId, 8, {}, (id, data) => {
            this.setState({tournament: data});
        });
	}
	isEventTournamentBlacklisted(event) {
		if (!Config.customConfig || !Config.customConfig.nextEventsHideCategory)
			return false; // Se non esiste la configurazione non blacklisto niente

		const tournament = PFeed.NStorage.get(event.parent);
		return tournament && Config.customConfig.nextEventsHideCategory.includes(tournament.parent)
	}
    openEvent(event) {
        const split = event.parent.split('/');
        const sportid = split[2];
        const categoryid = split[3];
        const tournamentid = split[4];
        const eventid = event.id.replace('/event/', '');
        route('/prematch/'+ sportid +'/' + categoryid + '/' + tournamentid +'/'+ eventid);
    }

	getLocalEventTime(event) {
		return new Date(event.date * 1000).toLocaleTimeString(undefined, {hour:'2-digit',minute:'2-digit'});
	}
	bestFourSports(menu) {
		return Object.values(menu)
			.filter(sport => this.preferredMarkets[sport.id])
			.sort((a, b) => a.order - b.order)
			.slice(0, 4)
	}
	setCurrentSport(sportId) {
		this.setState({
			currentSport: sportId,
			tournament: null
		});
		this.downloadSport(sportId);
	}
	isCurrentSport(sportId) {
		return this.state.currentSport == sportId;
	}
	getSomeEvents() {
		const sport = PFeed.menu[this.state.currentSport];
		if (!sport || !this.state.tournament)
			return [];
		return Object.values(this.state.tournament.sub)
			.filter(event => !this.isEventTournamentBlacklisted(event))
			.sort((a, b) => a.start - b.start)
			.slice(0, 6);
	}
	getCurrentSportId() {
		return this.state.currentSport;
	}
	preferredMarketForEvent(event) {
		return event.sub['/market/'+event.id.split('/')[2]+'/'+this.preferredMarkets[this.getCurrentSportId()].id];
	}

    render() {
        return <div>
		  <P.CardHeaderRow>
			<P.ThreeDots />
			<P.CardHeaderTitle><Trans>Last Minute</Trans></P.CardHeaderTitle>
			<P.CardHeaderSports>
			  {this.bestFourSports(PFeed.menu).map(sport => (
				<P.SportNameButton onClick={() => this.setCurrentSport(sport.id)} active={this.isCurrentSport(sport.id)}>
				  <M.SportFlagIcon sport={sport} /> {sport.name}
				</P.SportNameButton>
			  ))}
			</P.CardHeaderSports>
		  </P.CardHeaderRow>
		  <P.OddsTableHeadRow>
			<P.HeadRowCellId><Trans>Stats</Trans></P.HeadRowCellId>
			<P.HeadRowCellTime><Trans>Time</Trans></P.HeadRowCellTime>
			<P.HeadRowCellEvent><Trans>Event</Trans></P.HeadRowCellEvent>
			<P.OddsWidthContainer>
			  {this.preferredMarkets[this.getCurrentSportId()].outcomes == 3 ? <Fragment>
			    <P.HeadOddCell><Trans>1</Trans></P.HeadOddCell>
			    <P.HeadOddCell><Trans>X</Trans></P.HeadOddCell>
			    <P.HeadOddCell><Trans>2</Trans></P.HeadOddCell>
			  </Fragment>
			  : <Fragment>
			    <P.HeadOddCell><Trans>1</Trans></P.HeadOddCell>
			    <P.HeadOddCell><Trans>2</Trans></P.HeadOddCell>
			  </Fragment>}
			  <P.HeadMoreCell />
			</P.OddsWidthContainer>
		  </P.OddsTableHeadRow>
		  {this.getSomeEvents().map(event => <div>
			  <P.EventRow>
				<P.HeadRowCellId onClick={e => Page.openEventStats(event)}><StatsIconRegular class="h-4" /></P.HeadRowCellId>
				<P.HeadRowCellTime onClick={e => this.openEvent(event)}><span class="text-xxs">{this.getLocalEventTime(event)}</span></P.HeadRowCellTime>
				<P.ContentRowCellEvent onClick={e => this.openEvent(event)}>{event.home}{event.away ? ' - '+event.away : ''}</P.ContentRowCellEvent>
				<P.OddsWidthContainer>
					<PrematchEventOdds event={event} market={this.preferredMarketForEvent(event)} />
					<P.MoreButton onClick={e => this.openEvent(event)}>+</P.MoreButton>
				</P.OddsWidthContainer>
			  </P.EventRow>
		  </div>)}
		  <P.ShowMoreFooter><Trans>Show More</Trans> {">>"}</P.ShowMoreFooter>
		</div>;
    }
}

export class PrematchEventOdds extends Component {
    openEvent(event) {
        const split = event.parent.split('/');
        const sportid = split[2];
        const categoryid = split[3];
        const tournamentid = split[4];
        const eventid = event.id.replace('/event/', '');
        route('/prematch/'+ sportid +'/' + categoryid + '/' + tournamentid +'/'+ eventid);
    }

	render({market, event}) {
		return !!market ? Object.values(market.sub).map(outcome => (
			<P.EventOddButton
				value={outcome && outcome.value}
				selected={outcome && Ticket.hasPrematchOdds(outcome.id)}
				onClick={() => Ticket.togglePrematchOdds(outcome.id)} />
		)) : <P.OddsWidthEmpty />
	}
}